import React from "react";
import {translate, useAuth, useDomainEvent, useLogin} from "@soap/modules";
import {PrimaryActionMenuButton} from "@soap/baseweb";
import {getPostLoginReturnUrl} from "../constants/postLoginReturnUrl";
import {scheduleLogoutFromHomeHash} from "../constants/postLogoutReturnUrl";
export function LoginControls() {
    
    const maintenance = window.LYW.maintenance===true;
    const {
        logIn
    } = useLogin();

    const {
        authEnabled,
        authReady,
        isAuthenticated
    } = useAuth();
    return (
        <div style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            marginLeft: "auto"
        }}>
            <PrimaryActionMenuButton
                $style={{
                    paddingTop: "1px",
                    paddingBottom: "1px",
                    height:"35px"
                }}
                disabled={maintenance}
                onClick={() => {
                    if (authReady && authEnabled) {
                        if (isAuthenticated) {
                            scheduleLogoutFromHomeHash();
                        } else {
                            logIn(getPostLoginReturnUrl());
                        }
                    }
                }}> {isAuthenticated ? "Logout" : "Log In"}
            </PrimaryActionMenuButton>
        </div>
    );
}